export const EditNodeTypes = {
  TITLE: "title",
  QUANTITY: "quantity",
};
